export default __webpack_public_path__ + "static/media/temperature-warm.f5abaed5.svg";